import React, { useState, useRef } from "react";
import { API, imgUrl } from "../../lib/storeApi";
import { UploadCloud, X, FileText } from "lucide-react";

const ImageUpload = ({ value, onChange, label = "Image", testid = "img-upload", accept = "image/*" }) => {
  const [busy, setBusy] = useState(false);
  const [drag, setDrag] = useState(false);
  const inputRef = useRef();
  const token = localStorage.getItem("sht_admin_token");
  const isPdf = value && /\.pdf($|\?)/i.test(value);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await fetch(`${API}/admin/upload`, { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd });
      if (!r.ok) throw new Error("upload failed");
      const d = await r.json();
      onChange(imgUrl(d.url));
    } catch (e) {
      alert("Upload failed. Please try a smaller file.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-3" data-testid={testid}>
      <label className="text-xs font-semibold text-slate-500 block mb-1">{label}</label>
      <div
        onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
        onDragLeave={() => setDrag(false)}
        onDrop={(e) => { e.preventDefault(); setDrag(false); upload(e.dataTransfer.files[0]); }}
        onClick={() => inputRef.current?.click()}
        className={`cursor-pointer border-2 border-dashed rounded-lg p-4 flex items-center gap-3 transition-colors ${drag ? "border-[#3b9dff] bg-[#3b9dff]/5" : "border-slate-300 hover:border-[#3b9dff]"}`}
      >
        {value ? (
          <div className="flex items-center gap-3 w-full">
            {isPdf
              ? <span className="h-12 w-12 flex items-center justify-center bg-[#3b9dff]/10 rounded"><FileText className="w-6 h-6 text-[#3b9dff]" /></span>
              : <img src={imgUrl(value)} alt="" className="h-12 w-12 object-contain bg-slate-50 rounded border border-slate-100" />}
            <span className="text-xs text-slate-500 flex-1 truncate">{value}</span>
            <button type="button" onClick={(e) => { e.stopPropagation(); onChange(""); }} data-testid={`${testid}-clear`} className="text-slate-400 hover:text-red-500"><X className="w-4 h-4" /></button>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-slate-500 text-sm">
            <UploadCloud className="w-5 h-5 text-[#3b9dff]" />
            {busy ? "Uploading…" : "Drag a file here, or click to choose"}
          </div>
        )}
      </div>
      <input ref={inputRef} type="file" accept={accept} className="hidden" data-testid={`${testid}-input`}
        onChange={(e) => upload(e.target.files[0])} />
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="…or paste a URL"
        data-testid={`${testid}-url`} className="w-full px-3 py-2 border border-slate-300 rounded-lg text-xs mt-2" />
    </div>
  );
};

export default ImageUpload;
